import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ToggleGroupCard, ToggleGroupCardItem } from '@/components/ui/toggle-group';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';
import { assetVisibilityOptionsRich } from 'src/containers/SoftwareEscrow/Technical';

type Props = {
  onAssetVisibilityChange: (value: boolean | null) => void;
  assetVisibility: boolean;
  party: EscrowPartyTypeEnum;
};

const partyDescriptionMap = {
  [EscrowPartyTypeEnum.Beneficiary]: `Do you want to see the deposited assets?\nIf enabled, you will be able to manage your own notification settings.`,
  [EscrowPartyTypeEnum.Depositor]: `Do you want to show the deposited assets to the beneficiary?\nIf enabled, the beneficiary will be able to manage their own notification settings.`,
};

const AssetVisibility = ({ onAssetVisibilityChange, assetVisibility, party }: Props) => {
  const onChange = (value: string) => onAssetVisibilityChange(value === '' ? null : value === 'true');

  return (
    <Card>
      <CardHeader>
        <CardTitle>Asset visibility</CardTitle>
        <CardDescription className="whitespace-pre-wrap">{partyDescriptionMap[party]}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <ToggleGroupCard
          type="single"
          className="flex-col w-full"
          onValueChange={onChange}
          value={assetVisibility.toString()}
        >
          {assetVisibilityOptionsRich.map(({ value, icon: Icon, label, description }) => (
            <ToggleGroupCardItem key={value} value={value} icon={Icon} title={label} description={description} />
          ))}
        </ToggleGroupCard>
      </CardContent>
    </Card>
  );
};

export default AssetVisibility;
